import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import EditFundraisingPage from 'src/components/Pages/EditFundraisingPage';

const EditFundraisingModal = () => (
  <ModalBase
    name={MODALS.editFundraising}
    size={MODALS_SIZE.medium}>
    <EditFundraisingPage />
  </ModalBase>
);

export default EditFundraisingModal;
